export { default } from './svg/menu-vert.svg';
